/// <reference path="../../../../typings/index.d.ts" />
angular.module('app').factory('UserConnectionServiceApi', ($http, ApiErrorService) => {
    return {
        getConnectionStatus: getConnectionStatus,
        stopConnection: stopConnection,
        startConnection: startConnection,
        getAllShortConnectionProfiles: getAllShortConnectionProfiles,
        getAllConnectionProfiles: getAllConnectionProfiles,
        selectConnectionProfile: selectConnectionProfile
    };
    function getConnectionStatus(simId, userId) {
        return $http.get(`api/usersimulator/connection/status?simId=${simId}&userId=${userId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function stopConnection(simId, userId) {
        return $http.post(`api/usersimulator/connection/stop?simId=${simId}&userId=${userId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function startConnection(simId, userId) {
        return $http.post(`api/usersimulator/connection/start?simId=${simId}&userId=${userId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getAllShortConnectionProfiles(simId, userId) {
        return $http.get(`api/usersimulator/shortconnectionProfiles?simId=${simId}&userId=${userId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getAllConnectionProfiles(simId, userId) {
        return $http.get(`api/usersimulator/connectionProfiles?simId=${simId}&userId=${userId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function selectConnectionProfile(simId, userId, simulatorUserConnectionId) {
        return $http.post(`api/usersimulator/connectionProfiles?simId=${simId}&userId=${userId}&simulatorUserConnectionId=${simulatorUserConnectionId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
});
